import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import styles from './Learn.module.css';

export interface TopicNav {
  slug: string;
  title: string;
}

interface Props {
  title: string;
  tagline: string;
  readTime: string;
  prev?: TopicNav;
  next?: TopicNav;
}

/** Consistent layout for every /learn/<topic> explainer.
 *  Breadcrumb, title, reading-time, content slot, prev/next nav. */
const LearnLayout: React.FC<PropsWithChildren<Props>> = ({ title, tagline, readTime, prev, next, children }) => {
  return (
    <article className={styles.article}>
      <nav className={styles.breadcrumb}>
        <Link to="/learn">Learn</Link>
        <span className={styles.breadSep}>/</span>
        <span>{title}</span>
      </nav>
      <header className={styles.articleHeader}>
        <h1>{title}</h1>
        <p className={styles.tagline}>{tagline}</p>
        <span className={styles.readTime}>{readTime}</span>
      </header>
      <div className={styles.content}>{children}</div>
      <nav className={styles.prevNext}>
        {prev ? (
          <Link to={`/learn/${prev.slug}`} className={styles.prev}>
            <span className={styles.dir}>← Previous</span>
            <span className={styles.label}>{prev.title}</span>
          </Link>
        ) : (
          <span />
        )}
        {next ? (
          <Link to={`/learn/${next.slug}`} className={styles.next}>
            <span className={styles.dir}>Next →</span>
            <span className={styles.label}>{next.title}</span>
          </Link>
        ) : null}
      </nav>
    </article>
  );
};

export default LearnLayout;
